import address from "@/storage/address";
import { ref, type Ref } from "vue";

export const alertMessageDeleteAddressHappyEmpty = {
    title: "",
    message: "",
    city: {
        address_id: 0,
        name_city: "",
        address_1: "",
        address_2: ""
    },
    class: "",
}

export interface IAlertMessageDeleteAddressHappy {
    title: string;
    message: string;
    class: string;
    city: {
        address_id: number
        name_city: string;
        address_1: string;
        address_2: string;
    };
}

export const alertMessageDeleteAddressHappy: Ref<IAlertMessageDeleteAddressHappy> = ref(alertMessageDeleteAddressHappyEmpty)